// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footerContainer {display: flex; width: 100%; flex-direction: column; border-top: 1px solid var(--brdrBlackLight); }", "",{"version":3,"sources":["webpack://src/styles/footerStyles.css"],"names":[],"mappings":"AAAA,kBAAkB,aAAa,EAAE,WAAW,EAAE,sBAAsB,EAAE,2CAA2C,EAAE","sourcesContent":[".footerContainer {display: flex; width: 100%; flex-direction: column; border-top: 1px solid var(--brdrBlackLight); }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
